export default {
  borderThickness: 2,
  containerMaxWidth: 1214,
  gameStepMaxWidth: 750
};